import type { ComponentChildren } from 'preact';
import type { ConnectionState } from '../lib/realtime.ts';
import type { PillKind } from '../lib/labels.ts';

export function Pill({ kind = '', children }: { kind?: PillKind; children: ComponentChildren }) {
  return <span class={`pill ${kind}`}><i aria-hidden="true" />{children}</span>;
}

export function Connection({ state }: { state: ConnectionState }) {
  const text = { connecting: 'Conectando…', live: 'En vivo', offline: 'Sin conexión en vivo: actualizando cada 5 s' }[state];
  return <span role="status"><Pill kind={state === 'live' ? 'live' : state === 'offline' ? 'warn' : ''}>{text}</Pill></span>;
}

export function ErrorBox({ error }: { error: string | null }) {
  return error ? <p class="error" role="alert">{error}</p> : null;
}
